import en from './en.json';
import pl from './pl.json';

function get_locales()
{
  return { en, pl }
}

function is_object(val) {
    return val !== null && typeof val === 'object';
}

function deep_merge(obj1, obj2)
{
  let result = {};
  for (let key in obj1)
  {
    if (obj2.hasOwnProperty(key) && is_object(obj1[key]) && is_object(obj1[key]))
    {
      result[key] = deep_merge(obj1[key], obj2[key]);
    } else if (obj2.hasOwnProperty(key))
    {
      result[key] = obj2[key];
    } else
    {
      result[key] = obj1[key];
    }
  }
  for (let key in obj2)
  {
    if (!obj1.hasOwnProperty(key))
    {
      result[key] = obj2[key];
    }
  }
  return result;
}

function get_lang()
{
  const defaultLanguage = 'en'; // Set a default language
  const supportedLanguages = ['en', 'pl']; // Set of supported languages

  const navigatorLanguage = navigator.language || navigator.userLanguage;
  const browserLanguage = navigatorLanguage.split('-')[0];

  if (!supportedLanguages.includes(browserLanguage))
  {
    return defaultLanguage;
  }

  return browserLanguage;
}

export { get_locales, deep_merge, get_lang };
